import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useShop } from '../../../Providers/ShopProvider'
import { useLocation } from 'react-router-dom'


const CategoryNavigationItem = ({ item, categoriesWithSameLevel, setActiveCategory, Icon, active, hideFeatureListFilter }) => {
    const navigate = useNavigate()
    const { setShowFeatureListFilter, productsFilter } = useShop()
    const [isHovered, setIsHovered] = useState(false);
    const location = useLocation()

    const handleNavigate = (category) => {
        let isShopPage = location.pathname.includes('shop')
        if (active) {
            setActiveCategory(null);
            localStorage.setItem("categoryNavigationTree", JSON.stringify(null));
        }
        else {
            setActiveCategory(category);
        }
        if (hideFeatureListFilter) {
            setShowFeatureListFilter(false)
        }
        else {
            setShowFeatureListFilter(true)
        }
        if (item.catDescription === 'Strona główna') {
            navigate('/')
        }
        else {
            if (productsFilter.SearchingQuery && productsFilter.SearchingQuery !== '' && productsFilter.SearchingQuery !== ' ') {
                navigate(`/Shop?q=${productsFilter.SearchingQuery}`)
            }
            else if (!isShopPage) {
                navigate('/shop')
            }
        }
    }
    return (
        item && <div className='col-auto category-navitation-item' onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <div className='row align-items-center' >
                <div className={`col category-navitation-item-tittle `} onClick={() => { handleNavigate(item); }}>
                    {Icon ? <Icon size={32} /> : item.catDescription}
                </div>
            </div>
            {categoriesWithSameLevel && isHovered && <div className='row category-navigation-popup'>
                <div className='col'>
                    {categoriesWithSameLevel && categoriesWithSameLevel.map(category => {
                        return <div className='row category-navitation-subItem' onClick={() => { handleNavigate(category) }
                        }>
                            {category.catDescription}
                        </div>
                    })}
                </div>

            </div>}

        </div >
    )
}

export default CategoryNavigationItem